import
React, {
  useState
} from 'react';

import PropTypes from 'prop-types';

import WithPopup from 'src/HOC/WithPopup/WithPopup';

import {
  checkInputValidity,
  isMobileView
} from 'src/Utility/utility';

import OTPInput from 'src/Components/OtpScreen/Components/OTPInput';
import Blocked from 'src/Components/OtpScreen/Components/Blocked';

import BlueTriangleRightArrow from 'src/Components/Common/Svg/BlueTriangleRightArrow';

import './OTP.css';

const OTP = (props) => {

  const contentStyleDesktop = {
    position: 'absolute',
    margin: 'auto',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%'
  };

  const contentStyleMobile = {
    margin: 'auto'
  };

  const contentStyleDesktopBlocked = {
    position: 'absolute',
    margin: 'auto',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
    background: 'white',
    height: '100%'
  };

  const contentStyleMobileBlocked = {
    position: 'absolute',
    margin: 'auto',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '100%',
    background: 'white',
    height: '100%'
  };

  const [ otpValue, setOtpValue ] = useState(
    {
      name: '*Enter OTP',
      type: 'input',
      value: '',
      validations: {
        required: true,
        minLength: props.otpLength,
        invalidMessage: 'Looks like you entered an invalid OTP. Please try again.',
        resendMessage: 'Your One-Time PIN has been resent. Please check your inbox.'
      },
      config: {
        type: 'number',
        required: true
      },
      isValid: false,
      isTouched: false,
      showResend: false
    }
  );

  const infoMsgOnclick = () => {

    const changedComponent = { ...otpValue };
    changedComponent.showResend = false;
    setOtpValue(changedComponent);
  };

  const otpHandler = (value) => {

    const changedComponent = { ...otpValue };
    changedComponent.value = value;
    changedComponent.validations.invalidMessage = 'Looks like you entered an invalid OTP. Please try again.';
    changedComponent.isValid = checkInputValidity(changedComponent.value, changedComponent.validations);
    changedComponent.isTouched = true;
    setOtpValue(changedComponent);
  };

  return (
    <div>

      { !props.isAccountBlocked
        ?(
          <WithPopup
            warningMsg={props.showError ? otpValue.validations.invalidMessage : ''}
            warningMsgOnclick={props.warningMsgOnclick}
            infoMessage={otpValue.showResend ? otpValue.validations.resendMessage : ''}
            infoMsgOnclick={infoMsgOnclick}
            contentStyle={isMobileView() ? contentStyleMobile : contentStyleDesktop}>

            <div className="otp-screen-wrapper">

              <button onClick={props.close} className="otp-screen-close-button">
                x
              </button>

              <div className="otp-screen-main-section">

                <div className="otp-screen-text-section">

                  <div className="enter-otp-text">Please enter your {props.otpLength}-digit OTP</div>

                  <div className="otp-sent-text">
                    {props.message}
                  </div>

                  <div className="otp-sent-text">Please enter it below to continue:</div>

                  <div className="otp-input-and-send-msg">

                    <div className="otp-input-wrapper">

                      <OTPInput
                        noOfDigits={props.otpLength}
                        otpHandler={otpHandler}/>
                    </div>

                    <div className="send-to-text">

                      <div
                        className="resend-otp-link"
                        onClick={() => props.onResendOtp(true)}>

                        Re-send OTP

                        <div style={{ marginRight: '8px', display: 'flex' }}>

                          <BlueTriangleRightArrow />
                        </div>

                      </div>

                    </div>
                  </div>
                </div>
              </div>

              <div className="otp-screen-footer-section">

                <div className="otp-screen-footer-btns">

                  <button
                    disabled={!otpValue.isValid}
                    className={'verify help-me-choose-plan-next-button'}
                    onClick={() => props.onSubmit(otpValue.value)}>

                    Submit OTP
                  </button>

                </div>
              </div>
            </div>
          </WithPopup>
        )
        :(
          <WithPopup
            contentStyle={isMobileView() ? contentStyleMobileBlocked : contentStyleDesktopBlocked}>

            <Blocked close={props.close} />
          </WithPopup>
        )
      }
    </div>
  );
};

OTP.propTypes = {
  close: PropTypes.func.isRequired,
  onResendOtp: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  showError: PropTypes.bool.isRequired,
  isAccountBlocked:  PropTypes.bool.isRequired,
  warningMsgOnclick: PropTypes.func.isRequired,
  otpLength: PropTypes.number
};

OTP.defaultProps = {
  otpLength: 4
};

export default OTP;